import React from 'react';
import styled from 'styled-components';
import AboutSection from '../components/sections/AboutSection';

const AboutPage = () => {
  return (
    <AboutPageContainer>
      <AboutSection />
    </AboutPageContainer>
  );
};

const AboutPageContainer = styled.div`
  padding-top: 2rem;
`;

export default AboutPage;